import { render, staticRenderFns } from "./LayoutSubNav.vue?vue&type=template&id=bc9484ca&scoped=true"
import script from "./LayoutSubNav.vue?vue&type=script&lang=js"
export * from "./LayoutSubNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutSubNav.vue?vue&type=style&index=0&id=bc9484ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9484ca",
  null
  
)

export default component.exports